import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import {
  FormatAlignLeftRounded as FormatLeftIcon,
  FormatAlignCenterRounded as FormatCenterIcon,
  FormatAlignRightRounded as FormatRightIcon,
  AutofpsSelectRounded as FormatAutoIcon
} from '@mui/icons-material';
import {
  FormRow,
  FormLabel,
  FormFieldWrapper,
  FormRowProps
} from '../form-input';
import { Alignment } from '../../framework';
import { useTranslation } from 'react-i18next';

export interface AlignmentFieldProps extends FormRowProps {
  label: string;
  value: Alignment;
  onChange: (value: Alignment) => void;
  includeAuto?: boolean;
}

export function AlignmentField(props: AlignmentFieldProps) {
  const { label, value, onChange, includeAuto, ...formRowProps } = props;

  const { t } = useTranslation();

  const handleChange = (_, newAlignment: Alignment) => {
    if (newAlignment !== null) {
      onChange(newAlignment);
    }
  };

  return (
    <FormRow {...formRowProps}>
      <FormLabel>{label}</FormLabel>
      <FormFieldWrapper>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleChange}
          aria-label="alignment"
        >
          {includeAuto && (
            <ToggleButton value="auto" aria-label="auto" title={t('auto')}>
              <FormatAutoIcon />
            </ToggleButton>
          )}
          <ToggleButton
            value="left"
            aria-label="left aligned"
            title={t('left')}
          >
            <FormatLeftIcon />
          </ToggleButton>
          <ToggleButton
            value="center"
            aria-label="centered"
            title={t('center')}
          >
            <FormatCenterIcon />
          </ToggleButton>
          <ToggleButton
            value="right"
            aria-label="right aligned"
            title={t('right')}
          >
            <FormatRightIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </FormFieldWrapper>
    </FormRow>
  );
}
